import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

import { Calendar, CalendarOptions } from '@fullcalendar/core';
import { FullCalendarComponent } from '@fullcalendar/angular';
import timeGridPlugin from '@fullcalendar/timegrid';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { ModalController } from '@ionic/angular';
import { TimeSlotComponent, TimeSlotTypes } from '../time-slot/time-slot.component';
import { EditComponent } from '../time-slot/edit/edit.component';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-calendar-setup',
  templateUrl: './setup.component.html',
  styleUrls: ['./setup.component.scss'],
})
export class SetupComponent implements OnInit {

  calendarOptions: CalendarOptions;
  @ViewChild('setupcalendar') calendarComponent: FullCalendarComponent;
  calendarAPI: Calendar = null;
  events = {
    message: 'Got Data',
    success: '1',
    status_code: 200,
    data: []
  }
  LoadedCalendar = false;
  ShowCalendar = false;

  calendarEvents = [
    { title: 'Event 1', start: new Date() } // Example event
  ];

  @Input() team_member;

  constructor(public globalService: GlobalService, private apiService: ApiService,private modalController: ModalController) { }

  ngOnInit() {
    console.log(this.team_member);
    this.DrawCalendar();
  }

  handleDateClick(arg: any) {
    this.presentAddTimeSlot(arg.date);
  }

  // Handle external events dropped into the calendar
  handleEventReceive(eventInfo: any) {
    console.log('External event received:', eventInfo);
  }

  // Optional: Handle drop event (custom logic)
  eventChanged(event: any) {
    console.log('Event Dropped:', event);
    let data = {
      start_time_iso: event.event.start.toISOString(),
      end_time_iso: event.event.end.toISOString(),
      day_of_week: dayjs(event.event.start).get("d"),
      tz_str: Intl.DateTimeFormat().resolvedOptions().timeZone,
      type: event.event._def.extendedProps.type
    }
    this.apiService.put(`calendar/setup/${event.event.id}`,data);
    //Update the timeslot for that event
  }

  handleClick(event: any) {
    this.presentEditModal(event);
  }

  async presentEditModal(event) {


    let time_slot = {
      guid: event.event.id,
      title: event.event.title,
      day_of_week: dayjs(event.event.start).get("d"),
      all_day: false,
      start_time: event.event.start,
      start_time_iso: event.event.start.toISOString(),
      end_time: event.event.end,
      end_time_iso: event.event.end.toISOString(),
      type: event.event._def.extendedProps.type,
      description: event.event._def.extendedProps.description
    }
    const modal = await this.modalController.create({
      component: EditComponent,
      cssClass: 'small-modal tall-modal secondary-modal',
      componentProps: {
        time_slot: time_slot,
      },
      backdropDismiss: false

    })
    modal.onDidDismiss().then((data: any) => {
      this.SetupCalendar();
    });
    return await modal.present()
  }

  async DrawCalendar() {
    //calendar settings
    this.calendarOptions = {
      plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
      initialView: 'timeGridWeek',
      headerToolbar: false, // Remove the default toolbar
      dayHeaderFormat: { weekday: 'long' }, // Display only the day name
      events: this.events.data, // You can leave this empty initially
      showNonCurrentDates: false, // Hide unnecessary "extra" days
      fixedWeekCount: false,
      displayEventTime: false, // Hide time on events if any
      slotMinTime: "00:00:00",
      slotMaxTime: "24:00:00",
      editable: true, // Allow event dragging within the calendar
      droppable: true, // For external draggable elements
      dateClick: this.handleDateClick.bind(this),
      allDaySlot: false,
      eventReceive: this.handleEventReceive.bind(this), // Fired when an external event is dropped
      height: "100%",
      eventDrop: this.eventChanged.bind(this), // Fired when a draggable element is dropped
      eventResize: this.eventChanged.bind(this),
      eventClick: this.handleClick.bind(this)
    };

    let count = 0;
    const interval = setInterval(() => {
      if (this.calendarComponent) {

        clearInterval(interval); // Stop checking once the condition is met
        this.calendarAPI = this.calendarComponent.getApi();
        console.log("Calendar Ready");
        this.SetupCalendar();

        this.LoadedCalendar = true;
        window.dispatchEvent(new Event('resize'))
      }
      else {
        console.log("Calendar Not Ready");
        count++;
        if (count > 3) {
          this.ShowCalendar = true;
        }
        if(count > 10) clearInterval(interval);
      }
    }, 500); // Check every 0.25 seconds


  }

  async Close() {
    this.modalController.dismiss();
  }


  async presentAddTimeSlot(start_time) {
    const modal = await this.modalController.create({
      component: TimeSlotComponent,
      cssClass: 'small-modal tall-modal secondary-modal',
      componentProps: {
        start_time: start_time,
        team_member: this.team_member
      },
      backdropDismiss: false

    })
    modal.onDidDismiss().then((data: any) => {
      this.SetupCalendar();
      if(data.data){
        console.log(data.data);

      }
    });
    return await modal.present()
  }

  async SetupCalendar() {
    let data: any = await this.apiService.get(`calendar/setup/${this.team_member.guid}`);

    if(data.success) {
      this.events.data.length = 0;
      //this.events.data = [];
      if(data.data) {
        for (const event of data.data) {
          //Loop through and format the data into the proper blocked out events.
        let formatted_event = this.convertToFullCalendarEvent(event);

        this.events.data.push(formatted_event);
        }
        

      }
    }
    console.log("Calendar SETUP");
    console.log(data);
  }

  convertToFullCalendarEvent(slot: any): any {
  const tzStr: string = slot.tz_str || Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Get the UTC offset in minutes for tzStr at the given date
  function getTZOffsetMinutes(date: Date): number {
    const utcStr = date.toLocaleString('en-US', { timeZone: 'UTC' });
    const tzStr_str = date.toLocaleString('en-US', { timeZone: tzStr });
    return (new Date(tzStr_str).getTime() - new Date(utcStr).getTime()) / 60000;
  }

  // Shift a UTC HHMM integer by the tz offset and set as local hours on a Date
  function utcHHMMToLocalDate(hhmm: number, baseDate: Date): Date {
    const offsetMinutes = getTZOffsetMinutes(baseDate);
    const totalMinutes = (Math.floor(hhmm / 100) * 60 + (hhmm % 100)) + offsetMinutes;
    let h = Math.floor(totalMinutes / 60) % 24;
    const m = ((totalMinutes % 60) + 60) % 60;
    if (h < 0) h += 24;
    const d = new Date(baseDate);
    d.setHours(h, m, 0, 0);
    return d;
  }

  // Calculate the current week's start day (Sunday)
  const today = new Date();
  const startOfWeek = new Date(today.setDate(today.getDate() - today.getDay()));
  startOfWeek.setHours(0, 0, 0, 0);

  // Determine the day for the event
  const eventDate = new Date(startOfWeek);
  eventDate.setDate(eventDate.getDate() + slot.day_of_week);

  const startDateTime = utcHHMMToLocalDate(slot.start_time, eventDate);
  const endDateTime = utcHHMMToLocalDate(slot.end_time, eventDate);

  // Determine the color based on slot type
  let colour = '';
  if (slot.type == TimeSlotTypes.appointment) {
    colour = '#ff9100';
  } else if (slot.type == TimeSlotTypes.work) {
    colour = '#004cff';
  } else if (slot.type == TimeSlotTypes.work_or_appointment) {
    colour = '#00ff00';
  }

  // Create FullCalendar-compatible event
  return {
    id: slot.guid,
    title: slot.title,
    color: colour,
    start: startDateTime.toISOString(), // Adjusted to user's local timezone
    end: endDateTime.toISOString(),
    allDay: false,
    extendedProps: {
      type: slot.type,
      description: slot.description
    },
  };
}




}
